import { environment } from '@environment';

export function isStorePreview(): boolean {
  return (
    environment.name === 'local' &&
    ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname) &&
    /^\/preview(?:\/|$)/.test(window.location.pathname)
  );
}
